import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { NO, YES } from "const"
import {
    StoreType,
    ChangePackageSettings,
    setPackageSettings,
} from "client/store"
import {
    Collapse,
    PageForm,
    FormGroup,
    Label,
    RadioButton,
} from "client/components"

const Okr = () => {
    const settings = useSelector((state: StoreType) => state.package.packageSettings)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)

    const onChange = (newSettings: ChangePackageSettings) => {
        dispatch(setPackageSettings(newSettings))
    }

    const { okrModuleAccess } = settings

    return (
        <Collapse
            show={show}
            title={lang.objectivesKeyResults}
            onCollapse={() => setShow(!show)}
        >
            <PageForm>
                <FormGroup>
                    <Label>{lang.okrModuleAccess}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={okrModuleAccess === NO}
                            onChange={() => onChange({ okrModuleAccess: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={okrModuleAccess === YES}
                            onChange={() => onChange({ okrModuleAccess: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>
            </PageForm>
        </Collapse>
    )
}
export default Okr
